import React, { useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  Menu,
  MenuItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Divider,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { useAccounts } from '../../hooks/useAccounts';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../util/auth';

export default function AccountSwitcher() {
  const { accounts, currentUserId, switchAccount } = useAccounts();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSwitchAccount = (id: number) => {
    if (id !== currentUserId) {
      switchAccount(id);
    }
    handleClose();
  };

  const handleAddAccount = () => {
    handleClose();
    navigate('/login?addAccount=true');
  };

  const handleLogoutAll = () => {
    handleClose();
    logout(true);
    navigate('/login');
  };

  if (accounts.length === 0) {
    return null;
  }

  return (
    <Box>
      <Button
        onClick={handleClick}
        variant="outlined"
        fullWidth
        startIcon={<SwapHorizIcon />}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        sx={{
          textTransform: 'none',
          borderRadius: 2,
          py: 1.5,
          fontWeight: 500,
        }}
      >
        Cambiar cuenta
      </Button>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        slotProps={{
          paper: { sx: { minWidth: 250 } },
        }}
      >
        <Typography variant="subtitle2" sx={{ px: 2, py: 1, color: 'text.secondary' }}>
          Cuentas
        </Typography>
        {accounts.map((account) => (
          <MenuItem
            key={account.id}
            onClick={() => handleSwitchAccount(account.id)}
            selected={account.id === currentUserId}
          >
            <ListItemAvatar>
              <Avatar alt={account.firstName} src={account.image} sx={{ width: 32, height: 32 }} />
            </ListItemAvatar>
            <ListItemText
              primary={`${account.firstName} ${account.lastName}`}
              primaryTypographyProps={{ variant: 'body2' }}
            />
            {account.id === currentUserId && (
              <CheckIcon fontSize="small" color="primary" sx={{ ml: 1 }} />
            )}
          </MenuItem>
        ))}
        <Divider sx={{ my: 1 }} />
        <MenuItem onClick={handleAddAccount}>
          <ListItemAvatar>
            <Avatar sx={{ width: 32, height: 32, bgcolor: 'grey.200' }}>
              <AddIcon fontSize="small" color="action" />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Añadir cuenta" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        <MenuItem onClick={handleLogoutAll}>
          <ListItemText
            primary="Cerrar todas las sesiones"
            primaryTypographyProps={{ variant: 'body2', color: 'error' }}
            sx={{ pl: 6 }}
          />
        </MenuItem>
      </Menu>
    </Box>
  );
}
